import { faStar } from '@rtkwlf/pro-regular-svg-icons/faStar';
import { useQuery } from '@tanstack/react-query';

import {
  useGetOrganizationOptions,
  useGetOrganizationSpidrBlueprintsOptions,
} from '@apis/track-public/query-options';
import { useDocumentTitle } from '@packages/fenrir/hooks/use-document-title';

import { Empty } from '../../../components/empty/empty';
import { useSecurityJourneyTranslations } from '../../../locales/use-security-journey-translations';
import {
  SpidrLibraryTabContent,
  SpidrLibraryTabContentDescription,
  SpidrLibraryTabContentTableContainer,
} from '../_components/spidr-library-tab-content/spidr-library-tab-content';
import {
  SpidrLibraryTable,
  parseBlueprintsForTable,
} from '../_components/spidr-library-table/spidr-library-table';
import { DEFAULT_ORG_TIER } from '../_constants/default-org-tier';
import { getFavouriteBlueprints } from '../_utils/get-favourite-blueprints';

export const FavoritesPage = () => {
  /**
   * Init translations
   */
  const { t } = useSecurityJourneyTranslations();

  /**
   * Set the document title
   */
  useDocumentTitle(t('spidrLibrary.favorites.documentTitle'));

  /**
   * get the current organization tier
   */
  const { data: orgTier } = useQuery({
    ...useGetOrganizationOptions(),
    select: (organization) => {
      return organization.tierInfo;
    },
    refetchOnMount: false,
  });

  /**
   * fetch all of the blueprints that have been favorited by the organization
   */
  const { data: favouriteBlueprints } = useQuery({
    ...useGetOrganizationSpidrBlueprintsOptions(),
    select: ({ blueprints }) => {
      return parseBlueprintsForTable(
        getFavouriteBlueprints(Object.values(blueprints)),
      );
    },
    refetchOnMount: false,
  });

  /**
   * checks if the organization has favorites
   */
  const hasFavouriteBlueprints =
    favouriteBlueprints && favouriteBlueprints.length > 0;

  return (
    <SpidrLibraryTabContent>
      {hasFavouriteBlueprints && (
        <SpidrLibraryTabContentDescription>
          {t('spidrLibrary.favorites.tabDescription')}
        </SpidrLibraryTabContentDescription>
      )}
      <SpidrLibraryTabContentTableContainer>
        {hasFavouriteBlueprints ? (
          <SpidrLibraryTable
            blueprints={favouriteBlueprints}
            orgTier={orgTier ?? DEFAULT_ORG_TIER}
          />
        ) : (
          <Empty
            icon={faStar}
            heading={t('spidrLibrary.favorites.noSpidrFavorited.heading')}
            message={t('spidrLibrary.favorites.noSpidrFavorited.message')}
          />
        )}
      </SpidrLibraryTabContentTableContainer>
    </SpidrLibraryTabContent>
  );
};

export const Component = () => <FavoritesPage />;
